export default function mockActivation(requestBody = {}) {
  const {
    status,
    locationType,
    translationEnabled,
    translationLanguage
  } = requestBody;
  if (!status || status === 'inactive') {
    return {
      activation: null
    };
  }
  return {
    activation: {
      mid: 10293,
      status,
      taggedAt: null,
      authUrl:
        'https://mc2-r4-33sdcp-pfv1m0ybx8st01.auth-qa1.marketingcloudqaapis.com/v1/requestToken',
      apiUrl:
        'https://mc2-r4-33sdcp-pfv1m0ybx8st01.rest-qa1.marketingcloudqaapis.com/',
      config: {
        maxTags: 20,
        minConfidence: 0.875,
        translationEnabled: translationEnabled || 'N',
        translationLanguage: translationLanguage || '',
        suffix: '.ai'
      },
      parentTagId: 123334,
      version: 1,
      useNestedTagApi: true,
      locationType: locationType || 'all'
    }
  };
}
